import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Zap, Brain, ShieldPlus } from 'lucide-react';
import SectionHeading from '../ui/SectionHeading';

const benefits = [
  {
    icon: Heart,
    title: 'Heart Healthy',
    description: 'Rich in monounsaturated fats that support cardiovascular health.',
  },
  {
    icon: Zap,
    title: 'High Protein',
    description: 'Packed with plant-based protein for lasting energy and muscle repair.',
  },
  {
    icon: Brain,
    title: 'Brain Boost',
    description: 'Contains essential nutrients like niacin and folate for cognitive function.',
  },
  {
    icon: ShieldPlus,
    title: 'Antioxidant Rich',
    description: 'Loaded with antioxidants to help fight free radicals in your body.',
  },
];

export default function PeanutBenefits() {
  return (
    <section className="py-20 md:py-28 bg-singaraa-cream relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-singaraa-caramel/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-singaraa-gold/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="NATURAL GOODNESS"
          title="Health Benefits of Peanuts"
          subtitle="Discover the incredible health benefits packed into every crunchy bite of our premium dry roasted peanuts."
          centered
        />

        <div className="mt-10 sm:mt-12 lg:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-singaraa-ivory p-8 rounded-2xl shadow-sm border border-singaraa-beige hover:shadow-xl hover:-translate-y-1 hover:border-singaraa-caramel/40 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-singaraa-beige/50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-singaraa-caramel/20 transition-colors">
                  <Icon className="text-singaraa-brown group-hover:text-singaraa-caramel transition-colors" size={28} strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-heading font-bold text-singaraa-dark mb-3">
                  {benefit.title}
                </h3>
                <p className="text-singaraa-dark/70 font-body leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
